import { ArrowRightIcon, CaretDownIcon, CaretUpIcon } from '@change/ds-icons';

import { Accordion, Link, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useTipsAndGuides } from './hooks/useTipsAndGuides';

export const TipsAndGuides: React.FC = () => {
	const {
		data: { tips },
		actions: { onTipLinkClick },
	} = useTipsAndGuides();

	return (
		<div className="container flex justify-center">
			<Accordion
				variant="un-contained"
				className="py-2"
				title={
					<Text variant="body" size="large" className="text-typography-interactive">
						<Translate value="corgi.homepage.how_to_sunrise.tips_and_guides.title" />
					</Text>
				}
				expandIcon={<CaretUpIcon className="text-typography-interactive" />}
				collapseIcon={<CaretDownIcon className="text-typography-interactive" />}
				headingClassName="group-active:!bg-transparent group-hover:bg-transparent px-2"
				data-qa="homepage-guide-links-list"
			>
				<div className="p-2">
					{tips.map((tip) => (
						<Link
							underline={false}
							key={tip.title}
							href={tip.guideLink}
							className="group block"
							onClick={() => onTipLinkClick(tip.guideLink)}
							data-qa="list-item"
						>
							<div className="border-t py-4 hover:underline focus:underline lg:min-w-[600px]">
								<div className="flex justify-between">
									<Text variant="body">{tip.title}</Text>
									<ArrowRightIcon
										size="medium"
										className="text-typography-interactive transition-transform duration-200 ease-out group-hover:translate-x-1"
									/>
								</div>
							</div>
						</Link>
					))}
				</div>
			</Accordion>
		</div>
	);
};
